import React, { FC } from 'react';
import { Box, Container, useTheme } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const HowItWorksSectionSkeleton: FC<any> = () => {
    const theme = useTheme();
    return (
      <Container maxWidth="xl">
        <Box sx={{ position: 'relative', maxWidth:'700px', margin:'auto' }} py={{ lg: 5, md: 1, sm:12 }}>
            
            <Skeleton variant="text" width="300px" height={80} />
            <Skeleton variant="text" width="100%" height={35} />
            <Skeleton variant="text" width="15s0px" height={90} sx={{ marginBottom:theme.spacing(3)}}/>
            {/* Timeline vertical line */}
            <Box
                sx={{
                    position: 'absolute',
                    left: 29,
                    top: 0,
                    bottom: 0,
                    width: '2px',
                }}
            />
    
              {[...Array(4)].map((_, item) => (
                <Box key={item} sx={{ position: 'relative' }}>
                    <Box
                        sx={{
                            p: 3,
                            borderLeft: '2px solid',
                            borderColor: theme.palette.secondary.main,
                            borderRadius: 1,
                        }}>
                        {/* Content */}
                        <Box>
                            <Skeleton variant="text" width="80px" height={30} />
                            <Skeleton variant="text" width="300px" height={50} />
                            <Skeleton variant="text" width="100%" height={80} />
                        </Box>
                    </Box>
    
                    {/* Timeline dot */}
                    <Box
                        sx={{
                            position: 'absolute',
                            left: -6,
                            top: 20,
                            width: 15,
                            height: 15,
                            borderRadius: '50%',
                            bgcolor: theme.palette.common.white,
                            border: `2px solid ${theme.palette.common.white}`,
                        }}
                    />
                </Box>
            ))}
        </Box>
      </Container>
    );
};

export { HowItWorksSectionSkeleton };